import React from "react";

const GolfHero = () => (
  <section className="relative h-[60vh] min-h-[500px] flex items-center">
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage:
          "url(/images/golf_hero.jpg)",
      }}
    >
      <div className="absolute inset-0 bg-[#1B2A4A]/70" />
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
      <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
        The Course
      </span>
      <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mt-3">
        Golf at Willow Ridge
      </h1>
      <p className="text-white/70 text-lg mt-4 max-w-xl">
        An 18-hole championship experience nestled among mature trees and
        scenic countryside in the heart of Chatham-Kent.
      </p>
    </div>
  </section>
);

export { GolfHero };
